import { Fragment } from 'react'
import s from './Files.scss'
import { getBaseUrl } from 'utils/api'
import cn from 'classnames'

const Files = ({ files, removeFile, withLinks, filesClassName, entityIndex = null }) => {
  return (
    <ul className={cn(s.files, filesClassName)}>
      {files.map(file => (
        <Fragment key={file.s3Key || file.lastModified}>
          {withLinks ? (
            <li key={file.s3Key} className={s.file}>
              {file.originalFileName ? (
                <a
                  href={`${getBaseUrl('/v1/test/get-s3-object')}/${file.s3Key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.originalFileName}
                </a>
              ) : (
                <span className={s.file}>{file.name}</span>
              )}
            </li>
          ) : (
            <li key={file.lastModified} className={s.file}>
              {file.name}
            </li>
          )}
          <span className={s.remove} onClick={() => removeFile(file.name, entityIndex)}>
            &times;
          </span>
          <div className={s.clearfix} />
        </Fragment>
      ))}
    </ul>
  )
}

export default Files
